"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
/**
 * Displays the publication status of a page in a pill.
 */
var PublicationStatus = function (_a) {
    var status = _a.status;
    return (react_1["default"].createElement("span", { className: "o-pill c-status" + (status.live ? ' c-status--live' : '') }, status.status));
};
PublicationStatus.propTypes = {
    status: prop_types_1["default"].shape({
        live: prop_types_1["default"].bool.isRequired,
        status: prop_types_1["default"].string.isRequired,
    }).isRequired,
};
exports["default"] = PublicationStatus;
